import { FuelButton } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';

export const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  z-index: 11;
  position: absolute;
  opacity: 0;
  transition: opacity 0.2s linear;

  @media (min-width: ${({ theme }) => theme.breakpoint.lg.minWidth}) {
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.33) 0%,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0) 70%,
      rgba(0, 0, 0, 0.33) 100%
    );
  }
`;

export const CounterBadge = styled.div`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spacing.km4};
    right: ${theme.spacing.km4};
    padding: ${theme.spacing.km1};
    border-radius: ${theme.border.radius.pill};
    background: ${theme.color.background.neutral.inverted}32;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    color: white;
    z-index: 13;
  `}
`;

export const NextButton = styled(FuelButton)`
  ${({ theme }) => css`
    position: absolute;
    right: ${theme.spacing.km4};
    top: 50%;
    transform: translateY(-50%);
    z-index: 12;
    opacity: 0;
    transition: opacity 0.2s linear;
  `}
`;

export const PreviousButton = styled(FuelButton)`
  ${({ theme }) => css`
    position: absolute;
    left: ${theme.spacing.km4};
    top: 50%;
    transform: translateY(-50%);
    z-index: 12;
    opacity: 0;
    transition: opacity 0.2s linear;
  `}
`;

export const DotsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.km2};
    position: absolute;
    bottom: ${theme.spacing.km4};
    left: 50%;
    transform: translateX(-50%);
    z-index: 13;
  `}
`;

export const Dot = styled.div<{ isActive?: boolean }>`
  ${({ theme, isActive }) => css`
    height: ${theme.spacing.km2};
    width: ${theme.spacing.km2};
    border-radius: ${theme.border.radius.circle};
    background: ${isActive ? theme.color.icon.neutral.inverted : theme.color.icon.neutral.default};
    cursor: pointer;
  `}
`;

export const ImagesWrapper = styled.div<{ marginLeft: number; isMouseDown: boolean }>`
  ${({ marginLeft, isMouseDown }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    transition: all ${isMouseDown ? '0' : '0.6'}s cubic-bezier(0, 0, 0.1, 1) 0s;
    transform: translate3d(${marginLeft}%, 0, 0);
  `}
`;

export const CarouselWrapper = styled.div<{ height: number; hasMultipleImages: boolean }>`
  ${({ theme, height, hasMultipleImages }) => css`
    height: ${height}px;
    max-height: ${height}px;
    border-radius: ${theme.border.radius.small};
    position: relative;
    z-index: 10;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    cursor: ${hasMultipleImages ? 'grab' : 'default'};

    &:hover {
      ${NextButton}, ${PreviousButton}, ${Backdrop} {
        opacity: 1;
      }
    }

    &:active {
      cursor: ${hasMultipleImages ? 'grabbing' : 'default'};
    }
  `}
`;

export const Image = styled.img`
  min-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: 50% 50%;
`;
